import { render, staticRenderFns } from "./alert-list.vue?vue&type=template&id=edef74f8&scoped=true"
import script from "./alert-list.vue?vue&type=script&lang=js"
export * from "./alert-list.vue?vue&type=script&lang=js"
import style0 from "./alert-list.vue?vue&type=style&index=0&id=edef74f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edef74f8",
  null
  
)

export default component.exports